import React, { useState, useEffect } from 'react';
import { initAnalytics } from '../analytics';

const CONSENT_KEY = 'cookieConsent';

const CookiesConsent = () => {
  const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    const consentGiven = localStorage.getItem(CONSENT_KEY);
    if (!consentGiven) {
      setShowConsent(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, 'accepted');
    initAnalytics();
    setShowConsent(false);
  };

  const handleDecline = () => {
    localStorage.setItem(CONSENT_KEY, 'declined');
    setShowConsent(false);
  };

  if (!showConsent) {
    return null;
  }

  return (
    <div
      className="dd-cookies-banner"
      style={{
      position: 'fixed',
      bottom: '2rem',
      left: '2rem',
      zIndex: 9999,
      maxWidth: '400px',
      width: 'calc(100vw - 4rem)'
    }}>
      <div style={{
        backgroundColor: '#f5f5dc',
        borderRadius: '12px',
        padding: '1.5rem',
        position: 'relative',
        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
        border: '1px solid #e5e7eb'
      }}>
        <h2 style={{
          fontSize: '1.25rem',
          fontWeight: 'bold',
          color: '#333',
          marginBottom: '0.75rem',
          textTransform: 'uppercase',
          letterSpacing: '0.05em'
        }}>
          Cookies Consent
        </h2>

        <div style={{ marginBottom: '1.5rem' }}>
          <p style={{
            fontSize: '0.9rem',
            color: '#555',
            lineHeight: '1.5',
            marginBottom: '0.75rem'
          }}>
            We use cookies to improve your web experience.
          </p>
          
          <p style={{
            fontSize: '0.9rem',
            color: '#555',
            lineHeight: '1.5',
            marginBottom: '0.75rem'
          }}>
            To find out more about the cookies we use, see our{' '}
            <a 
              href="/privacy" 
              style={{
                color: '#eab308',
                textDecoration: 'underline',
                fontWeight: '500'
              }}
            >
              Privacy Policy
            </a>.
          </p>
          
          <p style={{
            fontSize: '0.9rem',
            color: '#555',
            lineHeight: '1.5'
          }}>
            If you decline, analytics will not be loaded when you visit this website.
            Functional cookies required for booking and authentication will still be used.
          </p>
        </div>

        <div
          className="dd-cookies-actions"
          style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '0.75rem'
        }}>
          <button
            onClick={handleAccept}
            style={{
              backgroundColor: '#333',
              color: '#F5F0E8',
              border: 'none',
              padding: '0.75rem 1.5rem',
              borderRadius: '8px',
              fontSize: '0.9rem',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'background-color 0.2s ease'
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#555'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#333'}
          >
            Yes, Please.
          </button>
          
          <button
            onClick={handleDecline}
            style={{
              backgroundColor: '#f5f5dc',
              color: '#333',
              border: '2px solid #333',
              padding: '0.75rem 1.5rem',
              borderRadius: '8px',
              fontSize: '0.9rem',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#333';
              e.target.style.color = '#F5F0E8';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#f5f5dc';
              e.target.style.color = '#333';
            }}
          >
            No, Thanks.
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookiesConsent;
